var _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@ember/component';
import { action } from '@ember/object';
import { dismissModal } from '@market/ember';
import { hbs } from 'ember-cli-htmlbars';
// NOTE(steckel): You'd think you could extract 'business-messages-modal' into
// a constant and use it within the layout, but no...
const layout = hbs`
  <template {{open-modal}}>
    <Banking::Messages::ModalImpl
      @onBodyClick={{this.onBodyClick}}
      @onDismiss={{action dismiss}}
      @onSlideShow={{this.onSlideShow}}
      @modal={{this.modal}}
      business-messages-modal
    />
  </template>
`;
let Modal = (_class = class Modal extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "layout", layout);
    _defineProperty(this, "modal", void 0);
    _defineProperty(this, "onSlideShow", void 0);
    _defineProperty(this, "onDismiss", void 0);
    _defineProperty(this, "tagName", '');
  }
  async dismiss() {
    const element = document.querySelector('[business-messages-modal]');
    await dismissModal(element);
    this.onDismiss?.();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "dismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismiss"), _class.prototype)), _class);
export { Modal as default };